import { render } from "./EditJobTitle.vue?vue&type=template&id=61336c9a"
import script from "./EditJobTitle.vue?vue&type=script&lang=js"
export * from "./EditJobTitle.vue?vue&type=script&lang=js"

import exportComponent from "/home/paperspace/thehrway-basic/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__